module.exports = __webpack_public_path__ + "static/img/4.cc42060.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/4.png
// module id = UdEC
// module chunks = 0